(function ($) {
    $(document).ready(function () {

        mobile_selector();
        $(document).on('click','body .expertise-tabs .col-wrap .content-wrapper .list-unstyled li span .co',function (e) {
            e.preventDefault();
            var current = $(this);
            if (!current.hasClass('active')) {
                $('.expertise-tabs span.active').removeClass('active');
                current.parent().addClass('active');
            }
            var str = $(this).parent().attr("rel");
            $('#text-tab-' + str).addClass("text-show").siblings('div').removeClass("text-show");
            $('#img-tab-' + str).addClass("img-show").siblings('div').removeClass("img-show");

        });
        $('body .expertise-tabs .col-wrap .content-wrapper .mobile-tab .select-box li a').click(function (e) {
            e.preventDefault();
            var value = $(this).attr("rel");
            $('#text-tab-' + value).addClass("text-show").siblings('div').removeClass("text-show");
            $('#img-tab-' + value).addClass("img-show").siblings('div').removeClass("img-show");
            var heightImg = $('#img-tab-' + value).height();
            $('#img-tab-' + value).parent().css("height",heightImg+"px");

        });

        $(document)
            .on('mouseover','body .expertise-tabs .col-wrap .content-wrapper .list-unstyled li > span >span',function() {
                $(this).parent().addClass('hover-active');
            });
        $(document)
            .on('mouseout','body .expertise-tabs .col-wrap .content-wrapper .list-unstyled li > span >span',function() {
                $(this).parent().removeClass('hover-active');
            });
    });
    $(window).resize(function () {
        mobile_selector();
        var window_width = $(window).width();
        // if (window_width >= 768) {
            calc_height();
        // }
    });

    function calc_height() {
        var window_width = $(window).width();
        if (window_width >= 992) {
            var img_height = $(" .home-expertise-tabs.expertise-tabs .content-wrap  .col-img .bg-img").height();
            var content_height = $(" .home-expertise-tabs.expertise-tabs .content-wrap  .col-inner").height();
            if (img_height > content_height) {
                $(".home-expertise-tabs.expertise-tabs .content-wrap").css('height', img_height + 52);
            } else {
                $(".home-expertise-tabs.expertise-tabs .content-wrap").css('height', content_height + 52);
            }
            // console.log("hi");
        }
        else{
            $(".home-expertise-tabs.expertise-tabs .content-wrap").css('height', 'auto');
            $(".home-expertise-tabs.expertise-tabs .content-wrap").css('height', 'auto');
        }
        if(window_width<768){
            var heightImg = $('body .expertise-tabs .col-img .img-wrapper.img-show').height();
            $('body .expertise-tabs .col-img').css("height",heightImg+"px");
        }else{
            $('body .expertise-tabs .col-img').removeAttr('style');
        }
    }

    function mobile_selector() {
        var window_width = $(window).width();
        if (window_width <= 575) {
            //$(".select-box").css({'display': 'block'});
            $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab").css({'display': 'block'});
            $(".list-unstyled").css({'display': 'none'});
            $(".select-box li").change(function () {
                var target = $(this).children("li:selected").val();

                $('#' + target).addClass("text-show").siblings('div').removeClass("text-show");
                // //$('#' + target).show().css({'margin-left':'0px','transition':'all 0.9s ease-in-out 0s','max-width':'310px'}).siblings('div').hide().css({'margin-left':'-450px','transition':'all 0.9s ease-in-out 0s'});
                $('.expertise-tabs .img-wrapper#' + target).addClass("img-show").siblings('.img-wrapper').removeClass("img-show");
            });

            $(".select-box li").on("click", function () {
                var value = $(this).text();
                $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab button span").text(value);
                $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab .select-box").removeClass('select');
                $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab").toggleClass('active');

            });
            //////selectbox///////
            $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab button").unbind().on("click", function () {
                $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab .select-box").toggleClass('select');
                $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab").toggleClass('active');
            });

        } else {
            $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab").css({'display': 'none'});
            $("body .expertise-tabs .col-wrap .content-wrapper .mobile-tab").removeClass('active');
            $(".list-unstyled").css({'display': 'block'});
        }
    }

    $(window).on('load', function () {

        var window_width = $(window).width();
        // if (window_width >= 768) {
        calc_height();
        // }
    });

})(jQuery);






